<template>
  <v-container fluid>
    <material-card icon="mdi-collage" inline title="Photo Gallery">
      <!-- <router-link :to="{ name: 'photogallaryList' }">
        <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
        <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
      </router-link> -->
      <v-row>
        <v-col cols="12" sm="6" lg="4" v-for="photo in photoGallery" :key="photo.id">
          <v-hover>
            <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 6 : 2}  mx-auto`" v-bind="$attrs" v-on:click="gotoImages(photo.id)" outlined class="mx-auto" max-width="400">
              <v-list-item three-line>
                <v-list-item-content>
                  <div class="overline mb-4" v-text="photo.userOfType"></div>
                  <v-list-item-title class="headline mb-1 text-capitalize" v-text="photo.title"> </v-list-item-title>
                  <v-list-item-subtitle v-html="photo.description"></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-avatar rounded="lg" tile size="65" :color="photo.color">
                  <v-icon large dark>mdi-image</v-icon>
                </v-list-item-avatar>
              </v-list-item>

              <v-card-actions class="px-4">
                <span class="caption" v-text="photo.Date"></span>
                <v-spacer></v-spacer>
                <span class="caption">
                  Images Count:
                  <span class="body-2">{{ ` ${photo.imagesLength}` }}</span>
                </span>
              </v-card-actions>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>
</template>
<script>
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
import moment from 'moment'
// import Utils from '@/utils'
import { mapGetters } from 'vuex'
export default {
  name: 'photogallaryView',
  components: {
    MaterialCard
  },
  data () {
    return {
      show: false,
      fromDate: moment().format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
      maxToDate: moment().format('YYYY-MM-DD'),
      academicYears: [],
      academicYearID: '',
      stages: [],
      franchiseeArr: [],
      franchiseeID: '',
      UserType: '',
      photoGallery: [],
      images: [],
      isLoading: false
    }
  },
  async created () {
    await this.onFranchiseeChange()
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  methods: {
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }

        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
          this.academicYears = this.academicYear.academicYear
        } else {
          this.academicYearID = ''
        }
        this.inProgress = false
      }
      if (this.franchiseeID && this.academicYearID) {
        await this.Save()
      }
    },
    async Save () {
      if (!this.franchiseeID) {
        this.errMsg('Kindly select franchisee!')
        return false
      }
      if (!this.academicYearID) {
        this.errMsg('Kindly select Academic year!')
        return false
      }
      this.isLoading = true
      if (this.academicYearID && this.franchiseeID !== ' ') {
        try {
          this.fromDate = this.academicYears.toString().split('-')[0]
          this.toDate = this.academicYears.toString().split('-')[1]
          this.photoGallery = []
          const { data } = await http.get(`${constants.API_URL}/api/communication/photo-gallery/user-type`, {
            params: {
              academicYearID: this.academicYearID,
              franchiseeID: this.franchiseeID,
              startDate: `${this.fromDate}-04-01`,
              endDate: `${this.toDate}-03-31`
            }
          })
          if (data.length === 0) {
            this.$dialog.error({
              text: 'No Data Found',
              title: 'No Data'
            })
          } else {
            let photoGallery = []
            data.forEach(e => {
              if (e.isActive === true) {
                let color = ''
                let userOfType = ''
                if (e.userType === 'STAFF_STAFF') {
                  userOfType = 'ALL STAFF PHOTOS'
                  color = 'primary'
                }
                if (e.userType === 'STAFF_TEACHING') {
                  userOfType = 'TEACHING STAFF PHOTOS'
                  color = 'info'
                }
                if (e.userType === 'STAFF_NON_TEACHING') {
                  userOfType = 'NON TEACHING STAFF PHOTOS'
                  color = 'success'
                }
                if (e.userType === 'PARENT') {
                  userOfType = 'PARENT PHOTOS'
                  color = 'pink'
                }
                if (e.userType === 'STUDENT_WISE') {
                  userOfType = 'STUDENT PHOTOS'
                  color = 'warning'
                }
                if (e.userType === 'ALL') {
                  userOfType = 'ALL PHOTOS'
                  color = 'darkblue'
                }
                photoGallery.push({
                  Date: moment(e.createdAt, 'YYYY-MM-DD').format('YYYY-MM-DD'),
                  title: e.title,
                  description: e.descriptions,
                  from: `${e.user.firstName} ${e.user.lastName}`,
                  imagesLength: e.photoGalleryDocumentMaps.length,
                  id: e.id,
                  color,
                  userOfType
                })
              }
            })
            this.photoGallery = photoGallery
          }
          this.isLoading = false
        } catch (e) {
          this.isLoading = false
          const errorMessage = (e && e.response && e.response.data.message) || e.message
          console.log('Error While Getting Data', errorMessage)
        }
      }
    },

    gotoImages (id) {
      this.$router.push({ name: 'photogallaryViewImages', params: { ID: id } })
    },

    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
